import { render, staticRenderFns } from "./intergame.vue?vue&type=template&id=5228cd84&scoped=true"
import script from "./intergame.vue?vue&type=script&lang=ts"
export * from "./intergame.vue?vue&type=script&lang=ts"
import style0 from "./intergame.vue?vue&type=style&index=0&id=5228cd84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5228cd84",
  null
  
)

export default component.exports